import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './js/axios'
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
